
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("cIqq3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kq7Kc").then(()=>parcelRequire("l7wLD"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


var $0d4115166d685837$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["53cdY","index.c1a07fa2.js","kq7Kc","gs.cdc223ac.js","lJctk","gs.d16b1df5.wasm"]'));


function $df54fdbd4b4920e5$var$loadScript() {
    (parcelRequire("cIqq3"));
}
let $df54fdbd4b4920e5$var$Module;
function $df54fdbd4b4920e5$export$9848c51a4555488(dataStruct, responseCallback, progressCallback, statusUpdateCallback) {
    // first download the ps data
    fetch(dataStruct.psDataURL).then((response)=>{
        // read the data as an array buffer
        return response.arrayBuffer();
    }).then((arrayBuffer)=>{
        // release the URL
        window.URL.revokeObjectURL(dataStruct.psDataURL);
        window.InputBuffer = new Uint8Array(arrayBuffer) // avoid closure issues
        ;
        if (window.Module) {
            $df54fdbd4b4920e5$var$Module["calledRun"] = false; // bypass check
            $df54fdbd4b4920e5$var$Module["run"]();
            return;
        }
        //set up EMScripten environment
        $df54fdbd4b4920e5$var$Module = {
            preRun: [
                function() {
                    const FS = window.FS;
                    var data = FS.writeFile("input.pdf", window.InputBuffer);
                }
            ],
            postRun: [
                function() {
                    const FS = window.FS;
                    var uarray = FS.readFile("output.pdf", {
                        encoding: "binary"
                    }); //Uint8Array
                    var blob = new Blob([
                        uarray
                    ], {
                        type: "application/octet-stream"
                    });
                    var pdfDataURL = window.URL.createObjectURL(blob);
                    responseCallback({
                        pdfDataURL: pdfDataURL,
                        url: dataStruct.url
                    });
                }
            ],
            arguments: [
                "-sDEVICE=pdfwrite",
                "-dCompatibilityLevel=1.4",
                "-dPDFSETTINGS=/ebook",
                "-DNOPAUSE",
                "-dQUIET",
                "-dBATCH",
                "-sOutputFile=output.pdf",
                "input.pdf"
            ],
            print: function(text) {
                statusUpdateCallback(text);
            },
            printErr: function(text) {
                statusUpdateCallback("Error: " + text);
                console.error(text);
            },
            setStatus: function(text) {
                if (!$df54fdbd4b4920e5$var$Module.setStatus.last) $df54fdbd4b4920e5$var$Module.setStatus.last = {
                    time: Date.now(),
                    text: ""
                };
                if (text === $df54fdbd4b4920e5$var$Module.setStatus.last.text) return;
                var m = text.match(/([^(]+)\((\d+(\.\d+)?)\/(\d+)\)/);
                var now = Date.now();
                if (m && now - $df54fdbd4b4920e5$var$Module.setStatus.last.time < 30) // if this is a progress update, skip it if too soon
                return;
                $df54fdbd4b4920e5$var$Module.setStatus.last.time = now;
                $df54fdbd4b4920e5$var$Module.setStatus.last.text = text;
                if (m) {
                    text = m[1];
                    progressCallback(false, parseInt(m[2]) * 100, parseInt(m[4]) * 100);
                } else progressCallback(true, 0, 0);
                statusUpdateCallback(text);
            },
            noExitRuntime: true,
            totalDependencies: 0
        };
        $df54fdbd4b4920e5$var$Module.setStatus("Loading Ghostscript...");
        window.Module = $df54fdbd4b4920e5$var$Module;
        $df54fdbd4b4920e5$var$loadScript();
    });
}
const $df54fdbd4b4920e5$var$fileInput = document.getElementById("file-input");
const $df54fdbd4b4920e5$var$fileList = document.getElementById("file-list");
const $df54fdbd4b4920e5$var$uploadBtn = document.getElementById("upload-btn");
const $df54fdbd4b4920e5$var$downloadBtn = document.getElementById("download-btn");
$df54fdbd4b4920e5$var$fileInput.addEventListener("change", $df54fdbd4b4920e5$var$updateFileList);
$df54fdbd4b4920e5$var$uploadBtn.addEventListener("click", $df54fdbd4b4920e5$var$uploadFiles);
function $df54fdbd4b4920e5$var$updateFileList() {
    $df54fdbd4b4920e5$var$fileList.innerHTML = "";
    $df54fdbd4b4920e5$var$uploadBtn.disabled = $df54fdbd4b4920e5$var$fileInput.files.length === 0;
    Array.from($df54fdbd4b4920e5$var$fileInput.files).forEach((file, index)=>{
        const li = $df54fdbd4b4920e5$var$createDraggableListItem(file, index);
        $df54fdbd4b4920e5$var$fileList.appendChild(li);
    });
    $df54fdbd4b4920e5$var$downloadBtn.classList.add("hidden");
}
function $df54fdbd4b4920e5$var$createDraggableListItem(file, index) {
    const li = document.createElement("li");
    li.className = "py-2 px-3 bg-gray-50 rounded mb-2 text-sm text-gray-700 cursor-move";
    li.textContent = `${file.name} (${$df54fdbd4b4920e5$var$formatFileSize(file.size)})`;
    li.draggable = true;
    li.dataset.index = index;
    li.addEventListener("dragstart", $df54fdbd4b4920e5$var$dragStart);
    li.addEventListener("dragover", $df54fdbd4b4920e5$var$dragOver);
    li.addEventListener("drop", $df54fdbd4b4920e5$var$drop);
    li.addEventListener("dragenter", $df54fdbd4b4920e5$var$dragEnter);
    li.addEventListener("dragleave", $df54fdbd4b4920e5$var$dragLeave);
    return li;
}
function $df54fdbd4b4920e5$var$dragStart(e) {
    e.dataTransfer.setData("text/plain", e.target.dataset.index);
    e.target.classList.add("bg-blue-100");
}
function $df54fdbd4b4920e5$var$dragOver(e) {
    e.preventDefault();
}
function $df54fdbd4b4920e5$var$dragEnter(e) {
    e.target.classList.add("bg-yellow-100");
}
function $df54fdbd4b4920e5$var$dragLeave(e) {
    e.target.classList.remove("bg-yellow-100");
}
function $df54fdbd4b4920e5$var$drop(e) {
    e.preventDefault();
    const fromIndex = parseInt(e.dataTransfer.getData("text/plain"));
    const toIndex = parseInt(e.target.dataset.index);
    if (fromIndex !== toIndex) {
        const files = Array.from($df54fdbd4b4920e5$var$fileInput.files);
        const [movedFile] = files.splice(fromIndex, 1);
        files.splice(toIndex, 0, movedFile);
        const newFileList = new DataTransfer();
        files.forEach((file)=>newFileList.items.add(file));
        $df54fdbd4b4920e5$var$fileInput.files = newFileList.files;
        $df54fdbd4b4920e5$var$updateFileList();
    }
    e.target.classList.remove("bg-yellow-100");
}
function $df54fdbd4b4920e5$var$formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB"
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}
function $df54fdbd4b4920e5$var$uploadFiles() {
    let fileUrls = [];
    for (const file of $df54fdbd4b4920e5$var$fileInput.files){
        const url = window.URL.createObjectURL(file);
        fileUrls.push(url);
    }
    // console.log(fileUrls, fileInput.files)
    $df54fdbd4b4920e5$var$compressPDF(fileUrls[0], $df54fdbd4b4920e5$var$fileInput.files[0].name);
// Clear the file input and list after upload
// fileInput.value = '';
// updateFileList();
}
function $df54fdbd4b4920e5$var$downloadFile(blobURL, fileName) {
    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = blobURL;
    link.download = fileName;
    // Append to the document, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Release the object URL
    URL.revokeObjectURL(blobURL);
}
function $df54fdbd4b4920e5$var$compressPDF(pdf, filename) {
    const dataObject = {
        psDataURL: pdf
    };
    $df54fdbd4b4920e5$export$9848c51a4555488(dataObject, (element)=>{
        $df54fdbd4b4920e5$var$loadPDFData(element, filename).then(({ pdfURL: pdfURL })=>{
            // console.log({ pdfURL });
            $df54fdbd4b4920e5$var$setDownloadLink(pdfURL);
        });
    }, (...args)=>console.log("Progress:", JSON.stringify(args)), (element)=>console.log("Status Update:", JSON.stringify(element)));
}
function $df54fdbd4b4920e5$var$setDownloadLink(pdfURL) {
    $df54fdbd4b4920e5$var$downloadBtn.disabled = false;
    $df54fdbd4b4920e5$var$downloadBtn.classList.remove("hidden");
    $df54fdbd4b4920e5$var$downloadBtn.onclick = ()=>$df54fdbd4b4920e5$var$downloadFile(pdfURL, "compressed.pdf");
}
function $df54fdbd4b4920e5$var$loadPDFData(response, filename) {
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open("GET", response.pdfDataURL);
        xhr.responseType = "arraybuffer";
        xhr.onload = function() {
            window.URL.revokeObjectURL(response.pdfDataURL);
            const blob = new Blob([
                xhr.response
            ], {
                type: "application/pdf"
            });
            const pdfURL = window.URL.createObjectURL(blob);
            resolve({
                pdfURL: pdfURL
            });
        };
        xhr.send();
    });
}


//# sourceMappingURL=index.c1a07fa2.js.map
